import React from 'react'

const PageNotFound = () => {
  return (
    <div>
      Not Found
    </div>
  )
}

export default PageNotFound
